/**
 * OwenMessage - AI assistant message component
 * Design system version — uses tokens and Lucide icons
 */
import { Lightbulb, Info } from 'lucide-react';
import { OWEN_CHARACTER } from '../../config/owenAI';

const OwenMessage = ({ message, type = 'info', showAvatar = true, animate = true }) => {

  const typeIcon = type === 'tip'
    ? <Lightbulb size={16} color="var(--lk-primary-500)" />
    : type === 'success'
      ? <Info size={16} color="var(--lk-primary-500)" />
      : null;

  const borderColor = type === 'success' ? 'var(--lk-primary-200)' : 'var(--lk-border)';

  const content = (
    <div style={{
      backgroundColor: 'var(--lk-bg-surface-2)',
      border: `1px solid ${borderColor}`,
      borderRadius: 'var(--lk-radius-lg)',
      padding: 'var(--lk-space-4)',
    }}>
      <div style={{ display: 'flex', gap: 'var(--lk-space-3)', alignItems: 'flex-start' }}>
        {showAvatar && (
          <img
            src={OWEN_CHARACTER.avatar}
            alt=""
            style={{ width: 48, height: 48, borderRadius: '50%', objectFit: 'cover', flexShrink: 0 }}
          />
        )}

        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 'var(--lk-space-2)', marginBottom: 4 }}>
            <strong style={{ fontSize: 'var(--lk-text-sm)' }}>{OWEN_CHARACTER.name}</strong>
            <span style={{ fontSize: 'var(--lk-text-xs)', color: 'var(--lk-text-tertiary)' }}>{OWEN_CHARACTER.title}</span>
          </div>

          {typeof message === 'string' ? (
            <div style={{ color: 'var(--lk-text-tertiary)', fontSize: 'var(--lk-text-sm)', lineHeight: 1.6 }}>
              {message}
            </div>
          ) : (
            <div style={{ fontSize: 'var(--lk-text-sm)', lineHeight: 1.6 }}>{message}</div>
          )}
        </div>

        {typeIcon && <div style={{ flexShrink: 0 }}>{typeIcon}</div>}
      </div>
    </div>
  );

  return animate ? <div className="fade-in">{content}</div> : content;
};

export default OwenMessage;
